export default "__VITE_ASSET__Xpe$8UN8__"